export default "__VITE_ASSET__B1D5n1Qu__"